//import store from "@/store";

import store from "@/store";
import helpers from "@/lib/helpers";

export default {
    init: false,
    device_init: {},

    async can() {
        if ('bluetooth' in navigator) {
            console.log('Browser supports navigator.bluetooth.');

            try {
                if (await navigator.bluetooth.getAvailability()) {
                    console.log('Bluetooth hardware is available.');
                    return true
                } else {
                    console.log('Bluetooth hardware is not available.');
                }
            } catch {
            }
        }
        return false
    },

    async send(deviceName, dataToWrite, serviceUUID, characteristicUUID) {
        store.commit('activity_loading')

        try {
            let device
            if (!deviceName)
                throw new Error("BtLe device name required")

            console.log('Requesting Bluetooth device...');
            try {
                if (this.device_init[deviceName]) {
                    try {
                        const existing = await navigator.bluetooth.getDevices()
                        device = existing.find(device => device.name === deviceName);
                    } catch {
                    }
                }

                if (!device)
                    device = await navigator.bluetooth.requestDevice({
                        filters: [{name: deviceName}], // Filter devices by name
                        optionalServices: [serviceUUID] // Allow access to the specific service
                    });
                else
                    console.log('Btle existing paired device found')
            } catch (e) {
                if (e.name === 'SecurityError') {
                    if (await helpers.confirm('Attempt to print locally (Bluetooth)?')) {
                        await this.send(deviceName, dataToWrite, serviceUUID, characteristicUUID)
                        return
                    }
                }
                throw e
            }

            console.log(`Connecting to GATT server for device: ${deviceName}`);
            const server = await device.gatt.connect();

            console.log(`Getting service: ${serviceUUID}`);
            const service = await server.getPrimaryService(serviceUUID);

            console.log(`Getting characteristic: ${characteristicUUID}`);
            const characteristic = await service.getCharacteristic(characteristicUUID);

            const encoder = new TextEncoder();
            const dataBytes = encoder.encode(dataToWrite);

            // Split the data into 20-byte chunks
            const chunkSize = 20;
            for (let i = 0; i < dataBytes.length; i += chunkSize) {
                const chunk = dataBytes.slice(i, i + chunkSize);
                await characteristic.writeValue(chunk); // Sequentially write each chunk
            }

            this.device_init[deviceName] = true;
            console.log('Data written successfully!');
        } finally {
            store.commit('activity_done')
        }
    }
}